const awsConfig = {
  Auth: {
    region              : 'us-east-1',
    userPoolId          : 'us-east-1_oFhnJ3pEK',
    identityPoolId      : 'us-east-1:6cfea440-acc4-4679-b74e-10213813f544',
    userPoolWebClientId : '762f4d99gtt3otpjvpihug3pbt',
  },
  API: {
    endpoints: [
      { name: 'LivenessAPI', endpoint: 'https://pmhm1b8qwi.execute-api.us-east-1.amazonaws.com/Prod' },
      { name: 'RecognitionAPI', endpoint: 'https://fjidiwq40h.execute-api.us-east-1.amazonaws.com/imageProcessingRequest' },
      { name: 'ValidationAPI', endpoint: 'https://s28rj7rpa8.execute-api.us-east-1.amazonaws.com/Stage/ws/rest' },
      { name: 'CallbackAPI', endpoint: 'wss://eksa30bjp4.execute-api.us-east-1.amazonaws.com/dev' },
      { name: 'MessagingAPI', endpoint: 'https://ea1w717ym2.execute-api.us-east-1.amazonaws.com/api/' },
    ],
  },
};

export default awsConfig;
